import React from "react";
import { NavLink } from "react-router-dom";

import "./SystemDevelopmentContentStyles.css";

import BandC from "../assets/billing-collection.png";
import Acctg from "../assets/accounting.jpg";
import Inventory from "../assets/inventory.jpg";
import Queue from "../assets/queue.jpg";
import Brokerage from "../assets/brokerage.jpg";
import Biometrics from "../assets/biometrics.jpg";
import POS from "../assets/pos.jpg";
import OPP from "../assets/order-process-project.png";
import ASSET from "../assets/asset_project.png";

const SystemDevelopmentContent = () => {
  return (
    <div>
      <div className="container-col-2">
      <div className="left-container">
          <img className="image-size" src={ASSET} />
        </div>
        <div className="right-container">
          <h1>Fixed Asset Barcode Android Application</h1>
          <p>     
          A Fixed Asset Barcode Android Application is a mobile tool for Android devices that uses barcodes to streamline the tracking and management of fixed assets. It allows users to assign and scan unique barcodes for assets, facilitating easy access to and updating of information. This application improves efficiency and accuracy in fixed asset management.
          </p>
          <NavLink
            to="#"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Private Access
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={OPP} />
        </div>
        <div className="right-container">
          <h1>Manual Order Processing Script</h1>
          <p>     
          Created a script facilitating the conversion of text files that contains purchase orders into Excel format, enabling users to bypass manual data entry into our system. Users can effortlessly upload the converted file into the system, significantly reducing manual workload. This initiative marks a pivotal step in the company's digital transformation journey.
          </p>
          <NavLink
            to="#"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Private Access
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={Biometrics} />
        </div>
        <div className="right-container">
          <h1>Attendance System</h1>
          <p>
            Programmed and developed a desktop application for TVCXpress Manila
            Inc. to automate their attendance system, resulting in increased
            efficiency and accuracy in their operations. The application
            features biometric authentication, real-time reporting, and
            collaboration with their HR Department to meet the company's
            specific requirements.
          </p>
          <NavLink
            to="https://drive.google.com/file/d/1hGqQWCpuLtM2xlpiwAPHaiZtJ_64xRn7/view?usp=sharing"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Get Source Code
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={POS} />
        </div>
        <div className="right-container">
          <h1>Consumer Management System</h1>
          <p>
            Programmed and developed a desktop application for consumer
            management system that caters to Silay City Water District (SICIWA),
            San Juan Water District (SJWD), and South Luzon Water Corp. (SLWC).
            The application features a user-friendly interface, and automated
            consumer data recording to enhance their operations.
          </p>
          <NavLink
            to="https://drive.google.com/file/d/1hGqQWCpuLtM2xlpiwAPHaiZtJ_64xRn7/view?usp=sharing"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Get Source Code
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={Brokerage} />
        </div>
        <div className="right-container">
          <h1>Brokerage and Forwarding System</h1>
          <p>
            Programmed and developed a desktop application for brokerage and
            forwarding system for CAM Brokerage Corporation. The application
            features automated shipment monitoring, real-time reporting, and
            inventory management to improve the company's logistics operations.
          </p>
          <NavLink
            to="https://drive.google.com/file/d/1hGqQWCpuLtM2xlpiwAPHaiZtJ_64xRn7/view?usp=sharing"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Get Source Code
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={Queue} />
        </div>
        <div className="right-container">
          <h1>Queueing System</h1>
          <p>
            Programmed and developed a desktop application for queueing system
            for Silay City Water District (SICIWA). The application features
            real-time monitoring of customer queue status, automated queue
            management, and statistical data analysis to enhance customer
            service and reduce waiting time.
          </p>
          <NavLink
            to="https://drive.google.com/file/d/1hGqQWCpuLtM2xlpiwAPHaiZtJ_64xRn7/view?usp=sharing"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Get Source Code
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={Inventory} />
        </div>
        <div className="right-container">
          <h1>Inventory System</h1>
          <p>
            Programmed and developed a desktop application for inventory system
            for Camarines Sur Electric Cooperative (CASURECO 1). The application
            features automated inventory tracking, real-time reporting, and
            integration with their accounting system to optimize their inventory
            management process.
          </p>
          <NavLink
            to="https://drive.google.com/file/d/1hGqQWCpuLtM2xlpiwAPHaiZtJ_64xRn7/view?usp=sharing"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Get Source Code
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={Acctg} />
        </div>
        <div className="right-container">
          <h1>Accounting System</h1>
          <p>
            Programmed and developed a desktop application for accounting system
            for Silay City Water District (SICIWA) and Camarines Sur Electric
            Cooperative (CASURECO 1). The application features automated
            accounting tasks, financial reporting, and budget management to help
            the companies streamline their financial operations.
          </p>
          <NavLink
            to="https://drive.google.com/file/d/1hGqQWCpuLtM2xlpiwAPHaiZtJ_64xRn7/view?usp=sharing"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Get Source Code
          </NavLink>
        </div>
        <div className="left-container">
          <img className="image-size" src={BandC} />
        </div>
        <div className="right-container">
          <h1>Billing and Collection System</h1>
          <p>
            Programmed and developed a desktop application for billing and
            collection to multiple clients, including Metro Bangued Water
            District (MBWD), Silay City Water District (SICIWA), San Juan Water
            District (SJWD), Topline, South Luzon Water Corp. (SLWC), Marcins
            Corp., Hermosa Water District (HWD), Taal Water District (TWD),
            Villasis Water District (VWD), and Tanauan Water District (TWD). The
            application features automated billing and collection management,
            real-time reporting, and integration with the clients' existing
            systems to optimize their financial operations. The software has
            improved the clients' billing and collection processes, increased
            accuracy, and reduced turnaround time for payments.
          </p>
          <NavLink
            to="https://drive.google.com/file/d/1hGqQWCpuLtM2xlpiwAPHaiZtJ_64xRn7/view?usp=sharing"
            target="_blank"
            className="link-button"
            style={{color: '#e85a4f'}}
          >
            Get Source Code
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default SystemDevelopmentContent;
